import { createContext } from "react";
import { TranslationLabels } from "translations/TranslationLabels";

export enum Language {
  DE = "de",
  FR = "fr",
  IT = "it",
  EN = "en",
}

export type TranslationResourceObject<L, T> = {
  [key in Extract<L, string>]: T;
};

export interface ITranslationsContext extends TranslationLabels {
  currentLanguage: Language;
  allLanguages: Language[];
  changeLanguage: (lang: Language) => void;
  labels: TranslationLabels;
}

export const TranslationsContext = createContext<ITranslationsContext>({} as ITranslationsContext);
